import { useMemo, useCallback } from "react";
import { InitialState, FetchFn, FetchCallBackResult, useDataFetch } from "../../../../core";
import { AlertCountResponseEntry, operationaliseV2ApiService } from "..";

export const useFetchIncidentsCount = (
  opId: string,
  startTimeMillis: number,
  endTimeMillis: number,
  timeIntervalMillis: number,
  simulationId?: string,
  generateDemoData?: boolean,
  lazyFetch?: boolean
) => {
  const initialState = useMemo<InitialState<AlertCountResponseEntry[], string>>(
    () => ({
      data: [],
      error: null,
      isError: false,
      isFetching: !lazyFetch,
      isSuccess: false
    }),
    [lazyFetch]
  );

  const fetchFn = useCallback<FetchFn<AlertCountResponseEntry[], string>>(async () => {
    const result: FetchCallBackResult<AlertCountResponseEntry[], string> = {
      data: [],
      error: null,
      isError: false,
      isSuccess: false
    };

    try {
      const { data, error, message } = await operationaliseV2ApiService.getIncidentsCount(
        opId,
        startTimeMillis,
        endTimeMillis,
        timeIntervalMillis,
        simulationId,
        generateDemoData
      );

      result.data = data?.count || [];
      result.isError = error;
      result.isSuccess = !error;
      result.error = error ? message : "";
    } catch (err) {
      result.isError = true;
      result.error = err.message || err.toString();
    }

    return result;
  }, [endTimeMillis, generateDemoData, opId, simulationId, startTimeMillis, timeIntervalMillis]);

  return useDataFetch(fetchFn, initialState, lazyFetch);
};
